import { Box, Button, Link, Typography, useTheme } from "@mui/material";
import {
	CloudOffOutlined,
	FilterAltOffOutlined,
	HourglassEmptyOutlined,
} from "@mui/icons-material";
import useStyles from "./styles";

// Conteudo (icone/titulo/descricao/acao) de cada um dos 3 estados vazios nomeados no brief de design
// descricao pode ser string fixa ou funcao(entidade) quando o texto precisa interpolar o nome do item (templates/scripts)
const CONTEUDO_POR_TIPO = {
	"sem-clientes": {
		Icone: CloudOffOutlined,
		titulo: "Nenhum cliente com Zabbix cadastrado",
		descricao: (entidade) =>
			`Para comparar ${entidade} é preciso cadastrar um Acesso Web com a tag Zabbix em Clientes.`,
	},
	"sem-coleta": {
		Icone: HourglassEmptyOutlined,
		titulo: "Ainda não há coleta para estes clientes",
		descricao: (entidade) =>
			`Os clientes já estão cadastrados, mas a coleta de ${entidade} nunca rodou. Dispare a coleta para ver o comparativo.`,
	},
	"filtro-sem-resultado": {
		Icone: FilterAltOffOutlined,
		titulo: "Nenhum resultado para o filtro atual",
		descricao: "Ajuste a busca ou o status filtrado, ou limpe o filtro para ver tudo de novo.",
	},
};

export default function EstadoVazio({ tipo, onAction, disabled, entidade = "templates" }) {
	const theme = useTheme();
	const styles = useStyles(theme);
	const conteudo = CONTEUDO_POR_TIPO[tipo];

	if (!conteudo) return null;

	const { Icone, titulo } = conteudo;
	// Resolve a descricao, que pode ser string fixa ou funcao(entidade) - ver comentario do catalogo acima
	const descricao =
		typeof conteudo.descricao === "function"
			? conteudo.descricao(entidade)
			: conteudo.descricao;

	return (
		<Box sx={styles.container}>
			<Icone sx={styles.icon} />
			<Typography variant="subtitle1" sx={styles.titulo}>
				{titulo}
			</Typography>
			<Typography variant="body2" sx={styles.descricao}>
				{descricao}
			</Typography>
			{/* Acao especifica de cada estado: link para cadastro, disparo de coleta ou limpeza de filtro */}
			{tipo === "sem-clientes" && (
				<Link href="/home/perfil" underline="hover">
					Ir para Clientes
				</Link>
			)}
			{tipo === "sem-coleta" && (
				<Button
					variant="contained"
					size="small"
					disabled={disabled}
					onClick={() => onAction?.()}
				>
					Atualizar cache
				</Button>
			)}
			{tipo === "filtro-sem-resultado" && (
				<Button variant="outlined" size="small" onClick={() => onAction?.()}>
					Limpar filtro
				</Button>
			)}
		</Box>
	);
}
